import React from 'react';
import { GlobalSearchRegistryItem } from '../../interfaces/global-search';
import { GenericListItemContent } from './GenericListItemContent/GenericListItemContent';
import { HdDocLink } from '../../../components';
import { getDocLink } from '../../../docs/utils/docLinkHandler';
import styles from './Component.module.scss';
import { _algoliaService } from '../../../core/services/algolia.service';

export const GLOBAL_SEARCH_DOCS_KEY = 'docs';
const GLOBAL_SEARCH_DOCS_DEFAULT_SEARCH_TERM = 'create pipeline';

export const GlobalSearchDocsRegistry: GlobalSearchRegistryItem = {
  key: GLOBAL_SEARCH_DOCS_KEY,
  maxItemsWhenNoFiltersApplied: 4,
  sortOrder: 8,
  title: 'Documentation',
  filters: [
    {
      value: GLOBAL_SEARCH_DOCS_KEY,
      label: 'Documentation'
    }
  ],
  inMemoryFiltering: false,
  dataResolver: (filters) => _algoliaService.queryDocs(
    filters.search || GLOBAL_SEARCH_DOCS_DEFAULT_SEARCH_TERM
  )
    .then(res => {
      const productRoutes = res.map((item) => ({
        data: item,
        key: item.id,
        icon: item.icon,
        name: item.title,
        exitURL: getDocLink(item.url, '', {}),
        isExitURLExternal: true,
        searchKeywords: [],
      }));
      return [...productRoutes];
    }),
  renderItem: (item) => (
    <GenericListItemContent
      primaryText={(
        <HdDocLink
          label={item.name}
          docLink={(item.data as { url: string; }).url}
          className={styles.algoliaLink}
          icon='new-window'
          dataId='link'
          tabIndex={0}
        />
      )}
      primaryTooltipText={item.name}
      primaryTextClass='w-100'
      suffixIcon={item.icon}
    />
  )
};
